import React from 'react';
import { useTranslation } from 'react-i18next';
import { getPasswordComplexity } from '../../utils/validators';

interface PasswordRequirementsProps {
  password: string;
}

export const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password }) => {
  const { t } = useTranslation();
  const complexity = getPasswordComplexity(password);

  const rules = [
    { key: 'min_length', met: complexity.minLength },
    { key: 'uppercase', met: complexity.uppercase },
    { key: 'lowercase', met: complexity.lowercase },
    { key: 'number', met: complexity.number },
  ];

  return (
    <div className="text-sm">
      <p className="text-muted-foreground mb-1">{t('auth.password_requirements.title')}</p>
      <ul className="space-y-1">
        {rules.map((rule) => (
          <li
            key={rule.key}
            className={`flex items-center ${rule.met ? 'text-green-600' : 'text-muted-foreground'}`}
            aria-current={rule.met ? 'true' : 'false'}
          >
            <span className="mr-2" aria-hidden="true">
              {rule.met ? '✓' : '○'}
            </span>
            {t(`auth.password_requirements.${rule.key}`)}
          </li>
        ))}
      </ul>
    </div>
  );
};
